import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/list-v2.0.0'

export default reactNode(
	'List',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: false, docs: '' }
)
